var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "D9594A3B-5947-4BFE-AE42-7FB33E0122CD") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mobile-V3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HK---Account",
    transform: "translate(-342.000000, -270.000000)",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Black-/-Edit",
    transform: "translate(342.000000, 270.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(3.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.81812452,0.0642284172 L6.81812452,0.0642284172 L6.81812452,0.0642284172 L6.81812452,16.535657 L9.06422842,18.7817609 L11.3103323,16.535657 L11.3103323,0.0642284172 C10.0698434,-1.17626051 8.05861345,-1.17626051 6.81812452,0.0642284172 Z",
    id: "Line",
    transform: "translate(9.064228, 8.299943) rotate(45.000000) translate(-9.064228, -8.299943) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9096848,2.64448667 C12.7497691,2.7901435 13.4231369,3.11629754 13.9297882,3.62294881 C14.4364394,4.12960008 14.7940926,4.74611573 15.0027477,5.47249578",
    id: "Line-2"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.76c09847ca7db4756e280392e80afefe.svg";
export { ForwardRef as ReactComponent };